import { Route, Routes } from 'react-router-dom'

import List from './screens/List'

const TemplatePagesRoutes = () => (
  <Routes>
    <Route path="/" element={<List />} />
  </Routes>
)

export default TemplatePagesRoutes
